export const CHANGE_PROFILE_SIGNAL = 'changeProfile';
